export const productData = [{
    id: 0,
    name: "Dysto Hoodie",
    price: "220",
    description: "Product: Dysto Hoodie. Medium-bodied sourced terry, constructed from scratch/ hand sewn. Premium-quality. Oversized.",
    image: "/3_D_Trial_Product_ac19ec0ede.glb",
    poster:"https://cdn.glitch.com/f341fe61-4868-4d79-bad9-1a5804bea407%2Fposter.png?v=1627186159279",
    images: [ // Add an images array
    "https://i.ibb.co/s6bhDzs/5c2cda56a97bc40295eb8328.png",
    "https://i.ibb.co/PYFZWnD/5c2cda69a97bc40295eb832a.png"],
    custom1Name: "Size",
    custom1Options: "XS | S | M | L | XL | XXL",
    custom2Name: "Color",
    custom2Options: "Grey (Striped)",
    url:'https://mapso.co/products.json',
    crypto: "https://commerce.coinbase.com/checkout/8be76dd9-aaf7-4044-97c9-ec9c4c21868d"
},
{
    id: 1,
    name: "Dysto Cargos",
    price: "350",
    description: "Product: Dysto flared snow cargos. Heavy-bodied sourced vinyl with a duck-canvas texture, constructed from scratch/ hand sewn. Premium-quality.",
    image: "/3_D_Trial_Product_ac19ec0ede.glb",
    poster:"https://cdn.glitch.com/f341fe61-4868-4d79-bad9-1a5804bea407%2Fposter.png?v=1627186159279",
    images: [ // Add an images array
    "https://example.com/image1.jpg",
    "https://example.com/image2.jpg",
    "https://example.com/image3.jpg"],
    custom1Name: "Size",
    custom1Options: "28 | 30 | 32 | 34 | 36 | 38",
    custom2Name: "Color",
    custom2Options: "Black",
    url:'https://mapso.co/products.json',
    crypto: "https://commerce.coinbase.com/checkout/8be76dd9-aaf7-4044-97c9-ec9c4c21868d"
}]